import { Navigate, Outlet } from 'react-router-dom';
import { Spin } from 'antd';
import { useCurrentUser } from '@presentation/hooks/useAuth';
import { paths } from '@app/routes/paths';

export const ProtectedRoute = () => {
  const { data: user, isLoading } = useCurrentUser();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Spin size="large" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to={paths.login} replace />;
  }

  return <Outlet />;
};
